import React from "react";
import classes from "./Button.module.scss";
import { IButtonProps } from "../../../models/common/IButtonProps";
import { Button as BootStrapButton } from "react-bootstrap";
const Button = ({
  buttonClassName,
  containerClassName,
  text,
  ...props
}: IButtonProps) => {
  let buttonClass = classes.btn;
  let containerClass = classes.container;
  if (buttonClassName) {
    buttonClass = `${buttonClass} ${buttonClassName}`;
  }
  if (containerClassName) {
    containerClass = `${containerClass} ${containerClassName}`;
  }
  return (
    <div className={containerClass}>
      <BootStrapButton className={buttonClass} {...props}>
        {text}
      </BootStrapButton>
    </div>
  );
};

export default Button;
